import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import BackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

/**
 * Standard module page header: back arrow, title, subtitle.
 * Matches click2gro's components/PageHeader.tsx. Back defaults to the dashboard.
 */
export function PageHeader({
    title,
    subtitle,
    onBackClick,
}: {
    title: string;
    subtitle: string;
    onBackClick?: () => void;
}): React.JSX.Element {
    const navigate = useNavigate();

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, gap: 2 }}>
            <Tooltip title="Back">
                <IconButton
                    size="small"
                    onClick={() => {
                        if (onBackClick !== undefined) {
                            onBackClick();
                        } else {
                            void navigate('/');
                        }
                    }}
                >
                    <BackIcon />
                </IconButton>
            </Tooltip>
            <Box sx={{ flex: 1 }}>
                <Typography variant="h5" fontWeight={700} sx={{ color: 'text.primary' }}>
                    {title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {subtitle}
                </Typography>
            </Box>
        </Box>
    );
}
